// MOBILE NAV
$( ".js-nav-control" ).click(function() {
  $( 'body' ).toggleClass( "open" );
});


document.addEventListener(
  "DOMContentLoaded", () => {
    const menu = new MmenuLight(
        document.querySelector( "#mobileMenu" ),
        "(max-width: 600px)"
    );

    const navigator = menu.navigation();  
  }
);


// Footer Nav

function resizeHandler() {
  console.log("window resized");

  if ($(window).width() < 1024) {
    console.log("window smaller than 1024");
    
    $('.footer-nav ul').hide();
    $('.footer-nav ul').slideUp(200);
  } else{
     $('.footer-nav ul').show();
     $('.footer-nav-header').removeClass("expanded");
  }
 }

resizeHandler();

$(window).resize(resizeHandler);

$('body').on('click', '.footer-nav-header', function() { 
  if ($(window).width() < 1024) {
    $(this).next().slideToggle(200);
    $(this).toggleClass("expanded");
  }
});


// Smooth Scroll Animation
	var scroll = new SmoothScroll('a[href*="#"]');
	
// SEARCH 

$('.user-icons').on("click", function(e) {
  $('#search').hide();
});


$("body").on("click", '.js-show-search, .search-close', function(e) {
  $('.search-close').css('padding-top', $('.header').height() + 100 + 'px');

  if($('#search-pop').is(":visible") && $(window).scrollTop() == 0) {
    $(".index .header").removeClass('header_bar');
    $('.index .header .logo img').attr('src', $('.logo img').data('src-home'));
  } else {
    $(".index .header").addClass('header_bar');
    $('.index .header .logo img').attr('src', $('.logo img').data('src'));
  }

  $('#search-pop').fadeToggle('fast').find('input').focus();
  e.stopPropagation();
  e.preventDefault();
});



	// QTY Adjust
  
	/* JS Quantity Incrementers */
	jQuery(function(){
	  var j = jQuery; 
	  var addInput = '.js-qty-wrap'; 
  
	  j(addInput).each(function() { 
	    var inputEl = j(this).closest(addInput).find('input');
	    var n = inputEl.val(); 
	    var plusEl = j(this).closest(addInput).find('.plus');
	    var minEl = j(this).closest(addInput).find('.min');
	    //On plus click add 1 to n
	    plusEl.on('click', function(){
	      inputEl.val(++n);
	    });
	    //On min click 
	    minEl.on('click', function(){
	    //If n is bigger or equal to 1 subtract 1 from n 
	      if ( ( inputEl.val() ) >= 1) {
	        inputEl.val(--n);
	      } 
	    });
	  });
	});
	

// BEFORE AND AFTER
$(function(){
  $(".compare").twentytwenty({
    default_offset_pct: 0.7, // How much of the before image is visible when the page loads
    orientation: 'horizontal', // Orientation of the before and after images ('horizontal' or 'vertical')
    before_label: 'After', // Set a custom before label
    after_label: 'Before', // Set a custom after label
    no_overlay: true, //Do not show the overlay with before and after
    move_slider_on_hover: true, // Move slider on mouse hover?
    move_with_handle_only: true, // Allow a user to swipe anywhere on the image to control slider movement. 
    click_to_move: false // Allow a user to click (or tap) anywhere on the image to move the slider to that location.
  });
});


